// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__o5cNy","buttons":"PendingPaymentAlert_buttons__C1dnW"};